import Overlay from "../../Componentes/Overlay";
import Modal from "../../Componentes/Utils/Modal";
import Formulario from "../../Componentes/Utils/Formulario";
import FormComp from "../../Componentes/FormComp";

import { useModal } from "../../contexts/ModalContext";
import { useEffect, useState } from "react";
import SmallLoading from "../../Componentes/Utils/SmallLoading";
import { useParams } from "react-router-dom";
import { useToast } from "../../contexts/ToastContext";
import useApi from "../../hooks/useApi";

const disciplinas = [
    "ALMOXARIFADO",
    "ANDAIMES",
    "APOIO OPERACIONAL",
    "ARQUIVO TECNICO",
    "CALDEIRARIA",
    "CONSTRUÇÃO CIVIL",
    "CONTABIL",
    "ELETRICA E INSTRUMENTAÇÃO",
    "ENGENHARIA / PLANEJAMENTO",
    "FINANCEIRO",
    "FROTA",
    "IÇAMENTO E MOVIMENTAÇÃO DE CARGAS",
    "ISOLAMENTO TÉRMICO",
    "JURIDICO",
    "LAMINAÇÃO",
    "LOGÍSTICA E OPERAÇÃO",
    "MANUTENÇÃO DE VEÍCULOS",
    "MANUTENÇÃO ELETRICA",
    "MANUTENÇÃO PREDIAL",
    "MATERIAIS",
    "MANUTENÇÃO MECÂNICA",
    "MECÂNICA",
    "PINTURA",
    "QUALIDADE",
    "RESTAURANTE",
    "RH",
    "SERVIÇOS ADMINISTRATIVOS",
    "SERVIÇOS GERAIS",
    "SOLDAGEM",
    "SSMA",
    "SUPRIMENTOS",
    "TRATAMENTO TÉRMICO",
    "T.I",
    "TOPOGRAFIA",
    "TUBULAÇÃO"
]

const ModalEditInfo = ({ info, fetchData }) => {

    const { matricula } = useParams();
    const { closeModal } = useModal();
    const { notifySuccess, notifyError } = useToast();

    const api = useApi();

    const [loading, setLoading] = useState(true);

    const [formValues, setFormValues] = useState({
        ...(info || {}),
        gerente_mat: info?.gerente_mat || "",
        coordenador_mat: info?.coordenador_mat || "",
        tecnico_mat: info?.tecnico_mat || "",
        tem_folga: info?.tem_folga ? "SIM" : "NÃO",
    });

    const [contratos, setContratos] = useState([]);
    const [encarregados, setEncarregados] = useState([]);
    const [obras, setObras] = useState([]);

    const fetchItens = async () => {

        try {

            const [contratosRes, encarregadosRes, obrasRes] = await Promise.all([
                api.get('/Painel/assets/php/getContratos.php'),
                api.get('/Painel/assets/php/getLideres.php'),
                api.get('/Painel/API/GetObrasAtivas/')
            ]);

            setContratos(contratosRes.data.filter(value => value.centro_custo === formValues.centro_custo).map(contrato => contrato.nome_contrato))
            setEncarregados(encarregadosRes.data.map(value => ({
                value: value.MATRICULA,
                label: value.RA_NOMECMP
            })))
            setObras(obrasRes.data.map(obra => obra.OBRA))

        } catch (e) {

            console.error(e);

        } finally {

            setLoading(false);

        }

    }

    useEffect(() => {

        console.log(info);
        setFormValues((prev) => ({
            ...(prev || {}),
            ...(info || {}),
            gerente_mat: info?.gerente_mat || "",
            coordenador_mat: info?.coordenador_mat || "",
            tecnico_mat: info?.tecnico_mat || "",
            tem_folga: info?.tem_folga ? "SIM" : "NÃO",
        }));
        fetchItens();

    }, [info])

    const handleChange = (field, value, type = "text") => {
        let newValue = value

        if (type === 'money') {
            newValue = newValue.replace(/\D/g, "");
            newValue = newValue ? parseInt(newValue, 10) : 0;
            newValue = (newValue / 100).toFixed(2);
        }

        setFormValues((prev) => ({
            ...prev,
            [field]: newValue
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        setLoading(true);

        try {

            const payload = { ...formValues }
            payload.matricula = matricula
            payload.tem_folga = formValues.tem_folga === "SIM" ? 1 : 0

            await api.post('/Painel/API/Colaborador/SaveInfo/', payload)

            await fetchData();
            notifySuccess("Dados atualizados com sucesso!");
            closeModal();

        } catch (e) {

            console.error(e);
            const msg = e?.response?.data?.message || "Erro ao atualizar dados do colaborador.";
            notifyError(msg);

        } finally {

            setLoading(false);

        }
    }

    return (
        <>
            <Overlay state={true} >
                <Modal header={true} close={closeModal} >
                    <Formulario onSubmit={(e) => handleSubmit(e)} >
                        <FormComp
                            title="CRACHA"
                            type="text"
                            valor={formValues.cracha || ''}
                            changeFunc={(e) => handleChange("cracha", e.target.value)}
                        />
                        <FormComp
                            title="CONTRATO"
                            type="select"
                            options={contratos}
                            valor={formValues.contrato || ''}
                            changeFunc={(e) => handleChange("contrato", e.target.value)}
                        />
                        <FormComp
                            title="DISCIPLINA"
                            type="select"
                            options={disciplinas}
                            valor={formValues.disciplina || ''}
                            changeFunc={(e) => handleChange("disciplina", e.target.value)}
                        />
                        <FormComp
                            title="GERENTE"
                            type="select"
                            options={encarregados}
                            obj={true}
                            valor={formValues.gerente_mat || ''}
                            changeFunc={(e) => handleChange("gerente_mat", e.target.value)}
                        />
                        <FormComp
                            title="COORDENADOR"
                            type="select"
                            options={encarregados}
                            obj={true}
                            valor={formValues.coordenador_mat || ''}
                            changeFunc={(e) => handleChange("coordenador_mat", e.target.value)}
                        />
                        <FormComp
                            title="SUPERVISOR"
                            type="select"
                            options={encarregados}
                            obj={true}
                            valor={formValues.sup_mat || ''}
                            changeFunc={(e) => handleChange("sup_mat", e.target.value)}
                        />
                        <FormComp
                            title="TÉCNICO"
                            type="select"
                            options={encarregados}
                            obj={true}
                            valor={formValues.tecnico_mat || ''}
                            changeFunc={(e) => handleChange("tecnico_mat", e.target.value)}
                        />
                        <FormComp
                            title="ENCARREGADO"
                            type="select"
                            options={encarregados}
                            obj={true}
                            valor={formValues.enc_mat || ''}
                            changeFunc={(e) => handleChange("enc_mat", e.target.value)}
                        />
                        <FormComp
                            title="HOSPEDAGEM"
                            type="select"
                            options={["ALOJADO", "AUXÍLIO MORADIA", "LOCAL"]}
                            valor={formValues.hospedagem || ''}
                            changeFunc={(e) => handleChange("hospedagem", e.target.value)}
                        />
                        <FormComp
                            title="EMPRESTADO"
                            type="select"
                            options={obras}
                            valor={formValues.locado || ''}
                            changeFunc={(e) => handleChange("locado", e.target.value)}
                        />
                        <FormComp
                            title="VALOR CARTÃO V.A"
                            type="number"
                            valor={formValues.valor_cartao_va || ''}
                            changeFunc={(e) => handleChange("valor_cartao_va", e.target.value, "money")}
                        />
                        <FormComp
                            title="VALOR MORADIA"
                            type="number"
                            valor={formValues.valor_moradia || ''}
                            changeFunc={(e) => handleChange("valor_moradia", e.target.value, "money")}
                        />
                        <FormComp
                            title="FOLGA DE CAMPO"
                            type="select"
                            options={["SIM", "NÃO"]}
                            valor={formValues.tem_folga || ''}
                            changeFunc={(e) => handleChange("tem_folga", e.target.value)}
                        />
                        <FormComp
                            type="submit"
                            valor="SALVAR"
                        />
                    </Formulario>
                </Modal>
            </Overlay>
            {
                loading && (
                    <Overlay state={true} >
                        <Modal size="sm" >
                            <SmallLoading />
                        </Modal>
                    </Overlay>
                )
            }
        </>
    )
}

export default ModalEditInfo;